import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function modalReducer(state = initialState.modalState, action) {
    switch(action.type) {
        case types.SHOW_MODAL:
        case types.HIDE_MODAL:
                return {
                    ...state,
                    showModal: action.type == types.SHOW_MODAL,
                    //modalContent: action.type == types.SHOW_MODAL ? action.content : null,
                    modalType: action.modalType
                };        
        default:
            return state;
    }
}